const Utils = {
  formatDate: (date) => {
    const strArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const dateObj = new Date(date);
    const d = dateObj.getDate();
    const m = strArray[dateObj.getMonth()];
    return `${d <= 9 ? `0${d}` : d} ${m}`;
  },
};

export default Utils;
